import { createBrowserRouter } from 'react-router-dom';
import ErrorPage from './error-page';

import { Root, rootLoader } from './routes/Root';

export const router = createBrowserRouter([
  {
    path: '/',
    id: 'root',
    loader: rootLoader,
    shouldRevalidate: () => true,
    errorElement: <ErrorPage />,
    element: <Root />,
    children: [
      {
        index: true,
        lazy: () => import('./routes/home'),
      },
      {
        path: 'plans',
        lazy: () => import('./routes/plans'),
      },
      {
        path: 'order',
        lazy: () => import('./routes/order'),
      },
      {
        path: 'confirmation',
        lazy: () => import('./routes/confirmation'),
      },
    ],
  },
]);
